class EspressoModal extends HTMLElement {
  #open = false;

  constructor() {
    super();

    this.modal = this.querySelector('#espresso-modal');
    this.mobileContent = this.querySelector('#espresso-modal .mobile-content');
    this.desktopContent = this.querySelector('#espresso-modal .desktop-content');
    this.openModalTrigger = this.querySelector('.espresso__open');
    this.closeModalTrigger = this.querySelector('.espresso__close');

    this.modal.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.openModalTrigger.addEventListener(
      'click',
      this.open.bind(this)
    );
    this.closeModalTrigger.addEventListener(
      'click',
      this.close.bind(this)
    );
    
    this.mobileContent.addEventListener('click', this.onModalClick.bind(this));
    this.desktopContent.addEventListener('click', this.onModalClick.bind(this));

    document.body.insertAdjacentElement('beforeend', this.modal);
  }

  isOpen() {
    return this.#open;
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('espresso-overlay')) this.close(false);
  }

  onModalClick(event) {
    event.stopImmediatePropagation();
  }

  open() {
    this.#open = true;
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
      this.modal.setAttribute('data-open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.modal,
      this.modal.querySelector('a'),
    );
  }

  close() {
    this.#open = false;
    removeTrapFocus(this.modal);
    this.modal.removeAttribute('data-open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('espresso-modal', EspressoModal);
